module.exports = __webpack_public_path__ + "img/BGgreen2.ffac9a7d.png";